// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KOG0","type":"styles_type__1YeEd","choices":"styles_choices__2DLSA"};